<template>
    <el-drawer
        title="排序管理"
        :visible="visible"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @open="show"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"

            >
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="24" :xl="24">
                        <el-form-item prop="code" label="城市:">
                            <city-select :value.sync="formData.code"></city-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :xl="24">
                        <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <el-table
                :data="tableData"
                style="width: 100%"
                size="small"
                stripe
                border
                v-loading="dataLoading"
                row-key="id"
                class="sortable MT20"
            >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="title" label="名称" min-width="200" show-overflow-tooltip></el-table-column>
            </el-table>
            <div v-if="tableData" class="MT10"><small><i class="el-icon-info"></i> 按住鼠标可拖动排<br/>这里仅支持对状态为【展示】的Banner进行排序操作</small></div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
import Sortable from "sortablejs";
import CitySelect from '@/components/CitySelect';

export default {
    components: {
        CitySelect
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            dataLoading: false,
            btnLoading:false,
            tableData:[],
            formData: {
                code: ''
            },
            sortForm: [],
            rules: {
                code: [{ required: true, message: "请选择城市" }],
            }
        }
    },
    methods:{
        close() {
            this.$emit('update:visible', false);
        },
        show() {
            this.formData.code = '';
            this.tableData = [];
        },
        async search(){
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.dataLoading = true;
                    const response = await this.$request({
                        url: '/banner/getBannerByCity',
                        params: this.formData
                    })
                    const {msg, state, result} = response.data;
                    this.dataLoading = false;
                    if (state != 1) return this.$message.error(msg);
                    this.tableData = result || [];
                    this.$nextTick(() => { 
                        this.drag(); 
                        this.updateSort();
                    }); 
                }
            });
            
        },
        drag(){
            const el = document.querySelectorAll('.sortable> .el-table__body-wrapper > table > tbody')[0];
            Sortable.create(el, {
                disabled: false, // 拖拽不可用? false 启用
                ghostClass: 'sortable-ghost', //拖拽样式
                animation: 150, // 拖拽延时，效果更好看
                onEnd: (e) => { // 拖拽结束时的触发
                    let arr = this.tableData; // 获取表数据
                    arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                    this.$nextTick(() => {
                        this.tableData = arr;
                        this.updateSort();
                    })
                },
            });
        },
        updateSort(){
            this.sortForm = []
            this.tableData.map((item,index) => {
                this.sortForm.push({
                    id: item.id,
                    sort: index
                })
            })
        },
        async submitForm(){
            this.btnLoading = true;
            const response = await this.$request({
                url: '/banner/sort',
                data: this.sortForm
            });
            const {msg, state} = response.data;
            this.btnLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.$emit('update:visible', false);
        }
    }
}
</script>